import { render, staticRenderFns } from "./NumericField.vue?vue&type=template&id=3b8c5e7f"
import script from "./NumericField.vue?vue&type=script&lang=js"
export * from "./NumericField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports